<div class="custom-scrollbar-css">
  <h2
    class="modal-title"
    style="margin-top: 3%; margin-left: 65px; font-weight: bold"
  >
    Nouvelle compagnie
  </h2>
  <hr style="
  border: 1px solid #262756;
  opacity: 0.23;
  width: 87%;
" />
  <ngx-spinner
    *ngIf="partnercompanycompanie ==true"
    bdColor="rgba(100,112,124,0.56)"
    size="medium"
    color="#233547"
    type="ball-clip-rotate-multiple"
    [fullScreen]="false"
  >
    <p style="color: white"></p>
  </ngx-spinner>
  <div class="container-fluid mt-3">
    <form [formGroup]="firstFormGroup">
      <div class="row">
        <div class="col-5 col-md-5 w-100" style="margin-left: 4%;">
          <h1 class="p-2">Hiérarchie</h1>
          <mat-form-field appearance="fill" class="w-100 mb-3">
            <mat-label>Revendeur</mat-label>
            <mat-select
              class="inputModal"
              formControlName="reseller_id"
              required
            >
              <mat-option
                *ngFor="let revendeurs of revendeurs"
                [value]="revendeurs.id"
              >
                {{revendeurs.name}}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="firstFormGroup.get('reseller_id').hasError('required')"
              >Revendeur est <strong>obligatoire</strong>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-1 col-md-1 w-100"></div>
        <div class="col-5 col-md-5 w-100" style="display: none">
          <h1 class="p-2">Informations sur contact</h1>
          <mat-form-field class="w-100 mb-3">
            <mat-label>Nom</mat-label>
            <input type="text" matInput pattern="[a-zA-Z ]*" />
          </mat-form-field>
          <mat-form-field class="w-100 mb-3">
            <mat-label>Courrier électronique</mat-label>
            <input type="email" matInput />
            <mat-icon matSuffix>alternate_email</mat-icon>
          </mat-form-field>
          <mat-form-field class="w-100 mb-3">
            <mat-label>Téléphone</mat-label>
            <input type="number" matInput maxlength="18" />
            <mat-icon matSuffix>perm_phone_msg</mat-icon>
          </mat-form-field>
          <mat-form-field class="w-100 mb-3">
            <mat-label>Numéro de téléphone mobile</mat-label>
            <input type="number" matInput maxlength="18" />
            <mat-icon matSuffix>perm_phone_msg</mat-icon>
          </mat-form-field>
        </div>
        <div class="col-5 col-md-5 w-100" style="margin-left: 4%;">
          <h1 class="p-2">Données du partenaire</h1>
          <mat-form-field class="w-100 mb-3">
            <mat-label>Nom</mat-label>
            <input
              matInput
              formControlName="name"
              [errorStateMatcher]="matcher"
              required
            />
            <mat-error *ngIf="firstFormGroup.get('name').hasError('required')"
              >Nom est <strong>obligatoire</strong>
            </mat-error>
            <mat-error *ngIf="firstFormGroup.get('name').hasError('pattern')">
              Veuillez saisir une format valide !
            </mat-error>
          </mat-form-field>
          <mat-form-field class="w-100 mb-3">
            <mat-label>Courrier électronique</mat-label>
            <input
              matInput
              formControlName="email"
              [errorStateMatcher]="matcher"
            />
            <mat-icon matSuffix>alternate_email</mat-icon>
            <mat-error *ngIf="firstFormGroup.get('email').hasError('email')"
              >Veuillez saisir une format valide !
            </mat-error>
          </mat-form-field>
          <mat-form-field class="w-100 mb-3">
            <mat-label>Téléphone</mat-label>
            <input
              matInput
              formControlName="gsm_number"
              maxlength="18"
              [errorStateMatcher]="matcher"
            />
            <mat-icon matSuffix>perm_phone_msg</mat-icon>
            <mat-error
              *ngIf="firstFormGroup.get('gsm_number').hasError('pattern')"
              >Veuillez saisir une format valide !
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-1 col-md-1 w-100"></div>
        <div class="col-5 col-md-5 w-100" style="display: none">
          <h1 class="p-2">Localisation</h1>
          <mat-form-field appearance="fill" class="w-100 mb-3">
            <mat-label>Sélectionner Pays </mat-label>
            <mat-select
              class="inputModal"
              (selectionChange)="onChangeCountry($event)"
            >
              <mat-option>--</mat-option>
              <mat-option
                *ngFor="let country of countryInfo; let i = index"
                [value]="i"
              >
                {{country.CountryName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill" class="w-100 mb-3">
            <mat-label>Sélectionner Ville</mat-label>
            <mat-select class="inputModal">
              <mat-option
                *ngFor="let state of stateInfo; let j = index"
                [value]="j"
                >{{state.StateName}}</mat-option
              >
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill" class="w-100 mb-3">
            <mat-label>Sélectionner Langue</mat-label>
            <mat-select disableRipple class="inputModal">
              <mat-option [value]="0">Francais</mat-option>
              <mat-option [value]="1">Anglais</mat-option>
              <mat-option [value]="2">Espagnol</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div></div>
    </form>
  </div>
</div>
<div class="justify-content-end d-flex" style="margin-right: 5%; margin-bottom: 40px;">
  <a
    *ngIf="!firstFormGroup.valid"
    class="savebtn mr-2"
    type="submit"
    aria-pressed="true"
    [ngClass]="{'disabled': !firstFormGroup.valid }"
    style="opacity: 0.5;"
    >Enregistrer</a
  >
  <a
    *ngIf="firstFormGroup.valid"
    class="savebtn mr-2"
    type="submit"
    aria-pressed="true"
    (click)="submitForm()"
    >Enregistrer</a
  >

  <a
    class="cancelbtn"
    type="submit"
    aria-pressed="true"
    (click)="onNoClick()"
    >Annuler</a
  >
</div>
